import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  NgZone,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {FormInputBase} from './model/form-input-base';
import {Subject} from 'rxjs';
import {MatSnackBar} from '@angular/material/snack-bar';

const Dot = require('dot-object');
@Component({
  selector: 'app-ng-material-form',
  templateUrl: './ng-material-form.component.html',
  styleUrls: ['./ng-material-form.component.css'],
})
export class NgMaterialFormComponent implements OnInit, OnChanges {
  @Input() renderFormField: FormInputBase<string | boolean>[] | null = [];
  @Input() formSubmitFromParent: Subject<any>;
  @Output('sentFormToParent') sentFormToParent: EventEmitter<any> = new EventEmitter();

  form: FormGroup;

  constructor(private _snackBar: MatSnackBar, private cdr: ChangeDetectorRef, private zone: NgZone) {}
  ngOnInit(): void {
    this.listenParentFormRequest();
    this.toFormGroup();
  }

  ngOnChanges(changes: SimpleChanges) {
    if ('renderFormField' in changes) {
      //
    }
  }

  // Returns whether the form exists and has been modified or not as a helper for the confirmation dialog
  hasFormUnsavedChanges(): boolean {
    return this.form && this.form.dirty;
  }

  private toFormGroup(): void {
    const group = {};

    (this.renderFormField || []).forEach((field) => {
      group[field.key] = field.required
        ? new FormControl(field.value || null, [...field.validators, Validators.required])
        : new FormControl(field.value || null, field.validators);
    });
    this.form = new FormGroup(group);
  }

  listenParentFormRequest() {
    this.formSubmitFromParent.subscribe((v) => {
      if (v.type == 'reset') {
        this.form.reset();
        this.sentFormToParent.emit({res: this.convertToObject(this.form.value), type: v.type, process: v.process});
      } else {
        this.form.markAllAsTouched();

        if (this.form.invalid) {
          this.sentFormToParent.emit(null);
          return;
        }
        this.sentFormToParent.emit({res: this.convertToObject(this.form.value), type: v.type, process: v.process});
      }
    });
  }

  convertToObject(res) {
    return this.zone.runOutsideAngular(() => {
      res = this.convertToNullValues(res);
      const dot = new Dot('->');
      dot.object(res);
      return res;
    });
  }

  convertToNullValues(formValue: any): any {
    const transformedValue = {};

    for (const key in formValue) {
      if (formValue.hasOwnProperty(key)) {
        const value = formValue[key];
        transformedValue[key] = value === '' || value === 'all' ? null : value;
      }
    }

    return transformedValue;
  }
  getColumn(controlType, classCss: string) {
    if (classCss) {
      return classCss;
    } else {
      if (controlType == 'newline' || controlType == 'header') {
        return 'col-12';
      } else {
        return 'col-lg-4 col-md-4 col-sm-12';
      }
    }
  }
}
